import { localizationEnUsSearch, routerPageSearch } from "./search";
import {
  localizationEnUsKnowledgeBase,
  routerPageKnowledgeBase,
} from "./knowledge-base";
import { localizationEnUsFaq, routerPageFaq } from "./faq";
import { localizationEnUsCases, routerPageCases } from "./cases";
import { localizationEnUsCaseView, routerPageCaseView } from "./case-view";

export const localizationEnUsSupport = {
  ...localizationEnUsSearch,
  ...localizationEnUsFaq,
  ...localizationEnUsKnowledgeBase,
  ...localizationEnUsCases,
  ...localizationEnUsCaseView,
};

export const routersPageSupport = [
  routerPageFaq,
  routerPageKnowledgeBase,
  routerPageCases,
  routerPageCaseView,
  routerPageSearch,
];
